import {
  ALERT_MODAL,
  SET_SIDEBAR_STATUS,
  ADD_TRAINER_MODAL,
  ADD_USER_MODAL,
  ADD_PRIVATE_MODAL,
  ADD_WOD_MODAL,
  ADD_CLASS_MODAL,
  ADD_MEMBER_MODAL,
  ADD_PACKAGE_MODAL,
  ADD_SALE_MODAL,
  ADD_STAFF_MODAL,
  ADD_APPOINTMENT_MODALL,
  COLLAPSE_SIDE_BAR,
  SET_RETAIL_MODAL,
} from "../types/types";

export const setSidebarStatus = (value) => {
  return {
    type: SET_SIDEBAR_STATUS,
    payload: { data: value },
  };
};
export const setCourtModal = (value) => {
  return {
    type: "SET_COURT_MODAL",
    payload: { data: value },
  };
};

export const addUserModal = (value) => {
  return {
    type: ADD_USER_MODAL,
    payload: { data: value },
  };
};
export const setRetailModal = (value) => {
  return {
    type: SET_RETAIL_MODAL,
    payload: { data: value },
  };
};

export const addTrainerModal = (value) => {
  return {
    type: ADD_TRAINER_MODAL,
    payload: { data: value },
  };
};

export const addClassModal = (value) => {
  return {
    type: ADD_CLASS_MODAL,
    payload: { data: value },
  };
};

export const addPrivateModal = (value) => {
  return {
    type: ADD_PRIVATE_MODAL,
    payload: { data: value },
  };
};
export const addWorkshopModal = (value) => {
  return {
    type: "ADD_WORKSHOP_MODAL",
    payload: { data: value },
  };
};

export const addWodModal = (value) => {
  return {
    type: ADD_WOD_MODAL,
    payload: { data: value },
  };
};

export const setAlertModal = (value) => {
  return {
    type: ALERT_MODAL,
    payload: { data: value },
  };
};

export const addPackageModal = (value, isEdit, editFields) => {
  return {
    type: ADD_PACKAGE_MODAL,
    payload: { data: value, isEdit, editFields },
    payload: { data: value, isEdit, editFields },
  };
};
export const addSaleModal = (value, isEdit, editFields) => {
  return {
    type: ADD_SALE_MODAL,
    payload: { data: value, isEdit, editFields },
  };
};
export const addStaffModal = (value, isEdit, editFields) => {
  return {
    type: ADD_STAFF_MODAL,
    payload: { data: value, isEdit, editFields },
  };
};
export const addAppointmentModal = (value) => {
  return {
    type: ADD_APPOINTMENT_MODALL,
    payload: { data: value },
  };
};
export const addServiceModal = (value) => {
  return {
    type: "ADD_SERVICE_MODAL",
    payload: { data: value },
  };
};
export const collapseSideBar = () => {
  return {
    type: COLLAPSE_SIDE_BAR,
  };
};

export const addGateModal = (value, isEdit = false, editFields = {}) => {
  return {
    type: "ADD_GATE_MODAL",
    payload: { data: value, isEdit, editFields },
  };
};

export const addFollowupProgramModal = (value) => {
  return {
    type: "ADD_FOLLOWUP_PROGRAM_MODAL",
    payload: { data: value },
  };
};